import {BaseEvent} from "main.core.events";
import {Select} from "./select";

import {mapState, mapMutations, mapActions} from "ui.vue3.vuex";

export const Filters =
    {
        data(): object {
            return {
                query: '',
                date: '',
            }
        },
        components: {
            Select
        },
        computed: {
            ...mapState('filtersStore', ['filterItems', 'search'])
        },
        mounted() {
            this.$Bitrix.eventEmitter.subscribe('apkpro:filters:send', this.onAlert);
        },
        beforeUnmount() {
            this.$Bitrix.eventEmitter.unsubscribe('apkpro:filters:send', this.onAlert);
        },
        methods: {
            ...mapMutations('filtersStore', ['setElement', 'setDate']),
            ...mapActions('filtersStore', ['sendFilters', 'resetFilter']),
            onAlert(event) {
                const {text} = event.getData();
                this.alertText = text;
            },
            sendForm() {
                this.setElement({name: 'search', value: this.query});
                this.sendFilters();
            },
            resetForm() {
                this.query = '';
                this.date = '';
                console.log('resetForm');
                this.$Bitrix.eventEmitter.emit('apkpro:select:clearOption')
                this.resetFilter();
                this.sendFilters();
            },
            changeDate() {
                console.log('changeDate');
                console.log(this.date);
                console.log(document.querySelector('[name="date"]').value);
                if (this.date === '' && document.querySelector('[name="date"]').value !== '') {
                    this.date = document.querySelector('[name="date"]').value;
                    let date = this.date.split(' - ');
                    let tmpFromDate = date[0].split('.')
                    let dateFrom = `${tmpFromDate[2]}/${tmpFromDate[1]}/${tmpFromDate[0]}`
                    let tmpToDate = date[1].split('.')
                    let dateTo = `${tmpToDate[2]}/${tmpToDate[1]}/${tmpToDate[0]}`

                    this.setDate({value: {from: dateFrom, to: dateTo}});
                    this.sendFilters();
                } else {
                    this.date = '';
                    this.setDate({value: {from: '', to: ''}});
                    this.sendFilters();
                }
            }
        },
        template: `
        <div class="methodological-filters">
        <form class="methodological-filters__form" @submit.prevent="sendForm" @reset.prevent="resetForm">
          <div class="methodological-filters__search">
            <div class="sb-font methodological-filters__subtitle">{{ $Bitrix.Loc.getMessage('TITLE_FILTERS_SEARCH_TITLE') }}</div>
            <div class="page-search page-search-big">
              <input type="text" v-model="query" class="page-search__field" :placeholder="$Bitrix.Loc.getMessage('TITLE_FILTERS_SEARCH_PLS')">
              <div class="page-search__right d-flex align-items-center">
                <button type="submit" class="btn btn-middle btn-fill-accent-2 page-search__btn">{{ $Bitrix.Loc.getMessage('TITLE_FILTERS_SEARCH_BTN') }}</button>
              </div>
            </div>
          </div>
          <div class="methodological-filters__variants">
            <div class="sb-font methodological-filters__subtitle">
                <span>{{ $Bitrix.Loc.getMessage('TITLE_FILTERS_FILTER_TITLE') }}</span>
                 <button type="reset" class="methodological-filters__reset">{{ $Bitrix.Loc.getMessage('TITLE_FILTERS_RESET_TITLE') }}</button>
            </div>
            <div class="methodological-filters__options">
                <template v-for="(value, index) in filterItems" :key="index">
                    <Select :element="value"/>
                </template>
                <label class="input methodological-filters__option">
                    Дата публикации
                    <input type="text" v-model="date" @change="changeDate" class="input__field input__field-lt js-datepicker" readonly autocomplete="off" data-test="2" name="date" placeholder="Дата публикации" />
                </label>
            </div>
          </div>
        </form>
      </div>
    `
    }